import { render } from "./Genres.vue?vue&type=template&id=5354b5bd"
import script from "./Genres.vue?vue&type=script&lang=js"
export * from "./Genres.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__